import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-partner__content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "card-partner__phone"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-phone-alt" }, null, -1)
const _hoisted_7 = {
  key: 2,
  class: "card-partner__mobil"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-mobile-alt" }, null, -1)
const _hoisted_10 = {
  key: 3,
  class: "card-partner__mail"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-envelope" }, null, -1)
const _hoisted_13 = {
  key: 4,
  class: "card-partner__mobil"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-globe" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Expand = _resolveComponent("Expand")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-partner", _ctx.classes]),
    ref: "root"
  }, [
    _createVNode(_component_Expand, null, {
      headline: _withCtx(() => [
        _renderSlot(_ctx.$slots, "headline")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnersFiltered, (partner, inx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: inx,
              class: "card-partner__partner"
            }, [
              (partner.value.point && partner.value.point.trim() !== '')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "card-partner__point",
                    innerHTML: partner.value.point
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "card-partner__contact-person",
                innerHTML: partner.value.title
              }, null, 8, _hoisted_3),
              (partner.value.phone && partner.value.phone.trim() !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("a", {
                      href: _ctx.getPhoneRef(partner.value.phone)
                    }, [
                      _hoisted_6,
                      _createTextVNode(" " + _toDisplayString(partner.value.phone.trim()), 1)
                    ], 8, _hoisted_5)
                  ]))
                : _createCommentVNode("", true),
              (partner.value.mobil && partner.value.mobil.trim() !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("a", {
                      href: _ctx.getPhoneRef(partner.value.mobil)
                    }, [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(partner.value.mobil.trim()), 1)
                    ], 8, _hoisted_8)
                  ]))
                : _createCommentVNode("", true),
              (partner.value.mail && partner.value.mail.trim() !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("a", {
                      href: `mailto:${partner.value.mail}`,
                      target: "_blank"
                    }, [
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(partner.value.mail), 1)
                    ], 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true),
              (partner.value.website && partner.value.website.trim() !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("a", {
                      href: `${partner.value.website}`,
                      target: "_blank"
                    }, [
                      _hoisted_15,
                      _createTextVNode(" " + _toDisplayString(partner.value.website), 1)
                    ], 8, _hoisted_14)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 3
    })
  ], 2))
}